import parse from "html-react-parser";

const PrintHTML = ({ text, className }) => {
  return <div className={`text-lg ${className}`}> {text && parse(text)}</div>;
};

export default PrintHTML;
